/** The ELPM Studio logo (black backdrop blends away on dark pages). */
export default function ElpmLogo({ className = "h-9", testId = "elpm-logo" }) {
  return (
    <img
      src="/brand/elpm-logo.png"
      alt="ELPM Studio"
      data-testid={testId}
      draggable="false"
      className={`w-auto select-none mix-blend-screen ${className}`}
    />
  );
}
